import { render } from "./app.vue?vue&type=template&id=a1efaea4"
const script = {}

import exportComponent from "C:\\Repos\\Sinter\\SinterAdmin\\src\\sa-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__